module.exports = __webpack_public_path__ + "static/media/tourism,hospitality&wellness.729d7a39.png";